import { GEOM_COLUMNS_LIST } from 'features/builder/ui/builderConstants'
import { DataExplorerResource, DataExplorerTable, AggregationOutputFormats, ImportFileForm } from './types'
import { SpatialIndex } from 'features/builder'
import { getGeoColumnFromTable } from 'features/builder/state/builderSliceUtils'
import { GeocodeableProviders } from './ui/DataExplorerGeocode/types'
import { ProviderType } from 'features/connections'
import { MapType } from 'features/maps/types'
import { MAX_FILE_SIZE_TO_IMPORT_IN_BYTES } from 'features/jobs/api/importJobs'

export function isValidGeom(tableObject: DataExplorerResource | DataExplorerTable) {
  return tableObject.geomField && GEOM_COLUMNS_LIST.indexOf(tableObject?.geomField.toLocaleLowerCase()) !== -1
}

export function isOptimizationMandatory(tableObject: DataExplorerTable) {
  if (
    tableObject.provider !== ProviderType.DATABRICKS_REST &&
    tableObject.provider !== ProviderType.DATABRICKS_WAREHOUSE
  ) {
    return false
  }
  const { hasSpatialIndex } = getGeoColumnFromTable(tableObject)

  if (hasSpatialIndex) {
    return false
  }

  return !!tableObject.optimization?.actionAvailable
}

export function getSpatialIndexResolutionValues(
  spatialIndex: SpatialIndex | AggregationOutputFormats,
  dataResolution = 0
) {
  let max = 0
  let defaultMax = 0

  switch (spatialIndex) {
    case SpatialIndex.H3:
    case AggregationOutputFormats.H3:
      max = dataResolution ? dataResolution - 4 : 11
      defaultMax = dataResolution ? max : 6
      break
    case SpatialIndex.QUADBIN:
    case AggregationOutputFormats.Quadbin:
      max = dataResolution ? dataResolution - 6 : 20
      defaultMax = dataResolution ? max : 12
      break
  }

  return {
    default: [0, defaultMax],
    minMax: [0, max]
  }
}

export function getNodePath({ id, connectionId, type }: { id?: string; connectionId?: string; type?: string }): string {
  let path = '/data/explorer'
  if (type === 'connection') {
    path += `/${connectionId}`
    return path
  }
  if (id && connectionId) {
    path += `/${connectionId}/${id?.replaceAll('.', '/')}`
  }
  return path
}

export function parseFqnTableName(fqn: string): { name: string; folderId: string } {
  const splitted = fqn.split('.')
  const tableName = splitted.pop()
  if (tableName === undefined) {
    throw new Error('invalid fqn')
  }
  return { name: tableName, folderId: splitted.join('.') }
}

export function isGeocodableTable(tableObject: DataExplorerTable) {
  if (tableObject.type === MapType.raster) {
    return false
  }
  const { geoColumn, hasSpatialIndex } = getGeoColumnFromTable(tableObject)
  const isProviderGeocodable = GeocodeableProviders.includes(tableObject.provider)
  return !!(!geoColumn && !hasSpatialIndex && isProviderGeocodable)
}

export function isValidImportFileSize(formData: Partial<ImportFileForm>): boolean {
  if (formData.file instanceof File) {
    return formData.file.size <= MAX_FILE_SIZE_TO_IMPORT_IN_BYTES
  }
  return true
}
